import dynamic from 'next/dynamic'
import LightGalleryItem from './LightGalleryItem'
import { ILightGalleryProps } from '../types'

const LightGallery = dynamic<ILightGalleryProps>(() => import('./LightGallery'), {
  ssr: false,
})

export { LightGallery, LightGalleryItem }
